import * as React from 'react'
import type { SVGProps } from 'react'
function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 192.2 76.42"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="c">
        <path d="M93.73,34.71h-16.62c3.29-3.69,5.31-8.54,5.31-13.86,0-11.5-9.36-20.86-20.86-20.86-8.46,0-16.02,5.04-19.26,12.85-.74,1.79.1,3.83,1.89,4.58,1.79.74,3.83-.1,4.58-1.89,2.16-5.19,7.18-8.54,12.8-8.54,7.64,0,13.86,6.22,13.86,13.86s-6.22,13.86-13.86,13.86H3.5c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5h58.06c.51,0,1.02-.04,1.52-.08.23.05.48.08.72.08h29.93c7.64,0,13.86,6.22,13.86,13.86s-6.22,13.86-13.86,13.86c-3.87,0-7.46-1.55-10.1-4.37-1.32-1.41-3.54-1.48-4.95-.16s-1.48,3.54-.16,4.95c3.93,4.18,9.47,6.58,15.21,6.58,11.5,0,20.86-9.36,20.86-20.86s-9.36-20.86-20.86-20.86Z" />
        <path d="M145.51,0c-8.46,0-16.02,5.04-19.26,12.85-.74,1.78.1,3.83,1.89,4.58,1.79.74,3.83-.1,4.58-1.89,2.16-5.19,7.18-8.54,12.8-8.54,7.64,0,13.86,6.22,13.86,13.86s-6.22,13.86-13.86,13.86h-29.33c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5h29.33c11.5,0,20.86-9.36,20.86-20.86S157.01,0,145.51,0Z" />
        <path d="M49.35,57.68H5.7c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5h43.65c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5Z" />
        <path d="M157.42,57.68h-12.37c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5h12.37c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5Z" />
        <path d="M98.71,24.36h12.37c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5h-12.37c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5Z" />
        <path d="M188.7,57.68h-12.91c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5h12.91c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5Z" />
      </g>
    </svg>
  )
}
export default Icon
